import React from 'react';
import PropTypes from 'prop-types';
import StyledButton from "./Button.Style"

/**
@typedef {Object} ButtonProps
 * @property {'primary' | 'secondary' | 'tertiary' | 'muted' | 'muted-primary'} variant
 * @param {ButtonProps & React.ComponentProps<'button'>} props
 */

const Button = ({ variant, children, ...props }) => {
    return (
        <StyledButton variant={variant} {...props} >
            {children}
        </StyledButton>
    );
};

Button.propTypes = {
    variant: PropTypes.oneOf([
        'primary',
        'secondary',
        'tertiary',
        'muted',
        'muted-primary',
    ]).isRequired,
    children: PropTypes.node.isRequired,
};

export default Button;
